import { ellipsis, numberFormatter } from '../../../helpers/formatter';

export const axisFormatter = (value) => {
  const type = typeof (value);
  switch (type) {
    case 'string':
      return ellipsis(value);
    case 'number':
      return numberFormatter(value);
    default:
      return value;
  }
};
